import { render, staticRenderFns } from "./LeftRightSection.vue?vue&type=template&id=00617685"
import script from "./LeftRightSection.vue?vue&type=script&lang=js"
export * from "./LeftRightSection.vue?vue&type=script&lang=js"
import style0 from "./LeftRightSection.vue?vue&type=style&index=0&id=00617685&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports